import * as VueRouter from 'vue-router';
import routes from './routes';
import middlewarePipeline from "../middlewares/middlewarePipeline";
import store from '../store';

routes.push({
  path: '/:catchAll(.*)',
  component: import(/* webpackChunkName: "404" */ '../views/errorPages/404.vue'),
})
const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(process.env.VUE_APP_BASE),
  routes, // short for `routes: routes`
})

router.beforeEach(async (to, from, next) => {
  const requiredPermissions = to.meta.requiredPermissions;
  const user = store.getters["auth/getUser"];

  if (requiredPermissions && user) {
    if (!store.getters["auth/permissionList"].length) {
      // Fetch permissions if not already fetched
      await store.dispatch('auth/getPermissions');
    }

    const userPermissions = store.getters["auth/permissionList"];
    const hasPermission = requiredPermissions.every(permission =>
        userPermissions.includes(permission)
    );

    if (!hasPermission) {
      return next('/403'); // or redirect to a "Not Authorized" page
    }
  }

  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware

  const context = {
    to,
    from,
    next,
    store
  }

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
});

export default router;